import { useEffect, useRef, type ReactNode } from 'react'
import { useAuth } from './AuthContext'
import { Loading } from '../components/Loading'

interface ProtectedRouteProps {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, login, user } = useAuth()
  const loginTriggeredRef = useRef(false)

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !loginTriggeredRef.current) {
      loginTriggeredRef.current = true
      login().catch(error => {
        console.error('Login redirect failed:', error)
        loginTriggeredRef.current = false
      })
    }
  }, [isLoading, isAuthenticated, login])

  if (isLoading || !isAuthenticated || (isAuthenticated && !user)) {
    return <Loading />
  }

  return <>{children}</>
}
